import { WarningTwoTone } from '@ant-design/icons';
import { Tooltip, Typography } from 'antd';
import React from 'react';
import { LANGUAGES } from '@guuru/languages-common';
import { COLORS } from '@guuru/theme-common';

interface LanguageFlagProps {
  languageCode?: string;
  showLanguage?: boolean;
  showAll?: boolean;
  size?: string;
  tooltipPreffix?: string;
  className?: string;
  style?: React.CSSProperties;
}

const LanguageFlag = function ({
  languageCode = undefined,
  showLanguage = false,
  showAll = false,
  size = '14px',
  tooltipPreffix = '',
  className = '',
  style = undefined,
}: LanguageFlagProps) {
  if (!languageCode) {
    return <WarningTwoTone twoToneColor={COLORS.yellow} />;
  }
  const code = languageCode.toLowerCase() as keyof typeof LANGUAGES;
  const language = LANGUAGES[code]?.name;
  if (showAll) {
    return (
      <Tooltip title={language ? `${tooltipPreffix}${language}` : ''}>
        <span className={className}>{` ${language}`}</span>
      </Tooltip>
    );
  }
  if (showLanguage) {
    return language;
  }
  return (
    <Tooltip title={language ? `${tooltipPreffix}${language}` : ''}>
      <span className={className}>
        <Typography.Text style={{ fontSize: size, ...style }} type="secondary">
          {language}
        </Typography.Text>
      </span>
    </Tooltip>
  );
};

export default LanguageFlag;
